module.exports = __webpack_public_path__ + "static/img/7areaB_02.97d8e0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_02.png
// module id = 1223
// module chunks = 1